/*
 * @Author: yuqiuyu 18180464352@163.com
 * @Date: 2022-06-16 17:25:03
 * @LastEditors: yuqiuyu 18180464352@163.com
 * @LastEditTime: 2022-07-04 16:50:02
 * @FilePath: \vueproject-master\src\utils\setTimer.js
 * @Description:
 *
 * Copyright (c) 2022 by 斯马特有限公司, All Rights Reserved.
 */

export function timeFormatSeconds(time) {
  var d = time ? new Date(time) : new Date();
  var year = d.getFullYear();
  var month = d.getMonth() + 1;
  var day = d.getDate();
  var hours = d.getHours();
  var min = d.getMinutes();
  var seconds = d.getSeconds();

  if (month < 10) month = "0" + month;
  if (day < 10) day = "0" + day;
  if (hours < 0) hours = "0" + hours;
  if (min < 10) min = "0" + min;
  if (seconds < 10) seconds = "0" + seconds;

  return (
    // year + "-" + month + "-" + day + " " + hours + ":" + min + ":" + seconds
    year + "-" + month + "-" + day + " " + hours + ":" + min
  );
}



// WEBPACK FOOTER //
// ./src/utils/setTimer.js